module.exports = {
      id: "double-arrow-usage",
      viewBox: "0 0 21.133 19.508",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#double-arrow",
      toString: function () {
        return this.url;
      }
    }